import React from 'react';
import { BsWhatsapp } from 'react-icons/bs';
import Styles from './whatsAppButton.module.css';

export default function WhatsAppButton() {
    const phoneNumber = '201285427034'; // Replace with your WhatsApp number
    const message = 'مرحباً، أريد الاستفسار عن...'; // Default message

    const handleClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    return (
        <button
            onClick={handleClick}
            className={Styles.whatsAppButton}
            aria-label="Contact on WhatsApp"
            title="تواصل معنا عبر واتساب"
        >
            <BsWhatsapp size={28} />
        </button>
    );
}
